import React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import Stack from '@mui/material/Stack';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/EditRounded';
import DeleteIcon from '@mui/icons-material/DeleteRounded';
import Tooltip from '@mui/material/Tooltip';
import { colors } from '../../../settings'

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#44b700',
        color: '#44b700',
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        '&::after': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            border: '1px solid currentColor',
            content: '""',
        },
    },
}));

export default function UsersTable(props) {

    if ((Array.isArray(props.users)) && (props.users.length === 0)) {
        return null
    }

    return (
        <TableContainer component={Paper}>
            <Table size="small" sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ width: 30, pr: 0 }} align="left"></TableCell>
                        <TableCell sx={{ width: 250 }} align="left">Name</TableCell>
                        <TableCell sx={{ width: 280 }} align="left">Email</TableCell>
                        <TableCell sx={{ width: 60 }} align="center">Role</TableCell>
                        <TableCell sx={{ width: 60 }} align="center">Online</TableCell>
                        <TableCell sx={{ width: 60 }} align="center">Status</TableCell>
                        <TableCell sx={{ width: 40 }} align="center">Actions</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.items?.map((row) => (
                        <TableRow
                            hover
                            key={row.id}
                            sx={{ cursor: 'pointer' }}
                            onClick={() => {props.btnEditHandle(row)} }
                        >
                            <TableCell align="left" sx={{ pr: 0 }}>
                                <StyledBadge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    variant={row.online ? 'dot' : 'none'}
                                >
                                    <Avatar alt="{row.firstname ?? '-'} {row.lastname ?? '-'}" src={row.avatar_url}/>
                                </StyledBadge>
                            </TableCell>
                            <TableCell align="left">
                                {row.firstname ?? '-'} {row.lastname ?? '-'}
                            </TableCell>
                            <TableCell align="left">{row.email}</TableCell>
                            <TableCell align="center">
                                <Chip size="small" label={row.role} />
                            </TableCell>
                            <TableCell align="center">
                                <Chip size="small" label={row.online ? 'online' : 'offline'} color={row.online ? 'success' : 'secondary'}/>
                            </TableCell>
                            <TableCell align="center">
                                <Chip size="small" label={row.status} color={row.status === 'active' ? 'success' : 'secondary'}/>
                            </TableCell>
                            <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
                                {
                                    ['super', 'admin'].indexOf(props.authUserRole) > -1
                                    ?
                                    <Tooltip arrow title="Edit User">
                                        <IconButton component="label" onClick={() => { props.btnEditHandle(row) }}>
                                            <EditIcon />
                                        </IconButton>
                                    </Tooltip>
                                    :
                                    null
                                }
                                {
                                    ['super', 'admin'].indexOf(props.authUserRole) > -1 && row.id !== props.authUserId
                                    ?
                                    <Tooltip arrow title="Delete User">
                                        <IconButton component="label" onClick={(e) => { e.stopPropagation(); props.btnDeleteHandle(row) }}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Tooltip>
                                    :
                                    null
                                }
                            </TableCell>
                            <TableCell />
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
